import { request } from 'sonata-react-components';
import { getSonataSession } from 'sonata-static-storage/lib/helpers/session.helpers';

export function getNews(draft: boolean, token: Record<string, any>) {
  return request.makeRequest(
    // @ts-ignore
    `${taptap.config.backendUrlBase}news?draft=${draft}`,
    {
      dataType: 'json',
      headers: getSonataSession(),
      method: 'GET'
    },
    token
  );
}

export function getNewsViewsById(newId: string, token: Record<string, any>) {
  return request.makeRequest(
    // @ts-ignore
    `${taptap.config.backendUrlBase}news/${newId}/views`,
    {
      dataType: 'json',
      headers: getSonataSession(),
      method: 'GET'
    },
    token
  );
}

export function postNewsViews(newsId: string, token: Record<string, any>) {
  return request.makeRequest(
    // @ts-ignore
    `${taptap.config.backendUrlBase}news/view`,
    {
      data: {
        newsId
      },
      headers: getSonataSession(),
      method: 'POST'
    },
    token
  );
}

export function updateNewsViews(newsViewsId: string, completed: boolean, page: number, token: Record<string, any>) {
  return request.makeRequest(
    // @ts-ignore
    `${taptap.config.backendUrlBase}news/view`,
    {
      data: {
        completed,
        newsViewsId,
        page
      },
      headers: getSonataSession(),
      method: 'PATCH'
    },
    token
  );
}
